import { styled } from '@linaria/react'
import { COLOR } from 'vars/index'

export const LabelAclBlockedCardSC = styled.div`
  position: absolute;
  inset: 0;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  background: var(${COLOR.SURFACE_OPACITY_DARK_70});
`
